$shm_dashboard_app_dashboard_list $mol_page
	dashboard_id? \default
	dashboard_model null $shm_ba_dashboard_model
	filter? \
	dashboard_rows_all /$mol_view
	title \Дашборды
	head /
		<= List_head $shm_dashboard_app_dashboard_list_head
			title <= title
			filter? <=> filter? \
			search_showed <= search_showed false
	body /
		<= Dashboard_menu $mol_list
			rows <= dashboard_rows /$mol_view
				<= Dashboard_link*0 $mol_link
					arg <= dashboard_arg* *
					current <= dashboard_current* false
					title <= dashboard_title* \
